import { KeyboardEvent, useCallback } from 'react';

import { NavigationMode, useFocusContext } from './JabraFocusContext';

export const useArrowKeyHandler = () => {
  const { moveFocus, orientation } = useFocusContext();

  return useCallback(
    (event: KeyboardEvent) => {
      const delta = getMoveDelta(event.key, orientation);
      if (delta === undefined) {
        return;
      }

      if (delta !== 0 && moveFocus(delta)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [orientation, moveFocus]
  );
};

export const getMoveDelta = (key: string, orientation: NavigationMode): number | undefined => {
  switch (key) {
    case 'ArrowUp':
      if (orientation === 'vertical' || orientation === 'both') {
        return -1;
      }
      return 0;
    case 'ArrowLeft':
      if (orientation === 'horizontal' || orientation === 'both') {
        return -1;
      }
      return 0;

    case 'ArrowDown':
      if (orientation === 'vertical' || orientation === 'both') {
        return 1;
      }
      return 0;
    case 'ArrowRight':
      if (orientation === 'horizontal' || orientation === 'both') {
        return 1;
      }
      return 0;
    default:
      return;
  }
};
